
import { Tooltip } from "antd";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { InfoCircleFilled } from "@ant-design/icons";
import { formatNumber, getPortfolioTypeTranslation } from "src/utils/helper/functions";

type AccountHedgeFundsProps = {
  assets: any[];
  view: string;
  seeFundDetails: (item: any) => void;
  setShowCashDetails: any;
  setShowAssetsDetails: any;
  setShowFundDetails: any;
};

const AccountHedgeFunds: React.FC<AccountHedgeFundsProps> = ({
  assets,
  view,
  seeFundDetails,
  setShowCashDetails,
  setShowAssetsDetails,
  setShowFundDetails,
}: AccountHedgeFundsProps): any => {
  const [portfolioData, setPortfolioData] = useState<any[]>([]);
  const [activePortfolio, setActivePortfolio] = useState<any>(null);

  useEffect(() => {
    const groupedData = assets
      .filter((item: any) => item.productGroupName === "Hedge Funds")
      .reduce((acc: any, obj: any) => {
        const key = obj.portfolioCode;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(obj);
        return acc;
      }, {});

    setPortfolioData(groupedData);
  }, [assets]);

  useEffect(() => {
    if (Object.keys(portfolioData).length === 1) {
      setActivePortfolio(Object.keys(portfolioData)[0]);
    }
  }, [portfolioData]);

  const getSumission = (data: any[], key: string): number => {
    return data
      ?.reduce(
        (accumulator, currentValue) => accumulator + currentValue[key],
        0
      )
      ?.toFixed(3);
  };

  const onAccountDetailsClicked = (portfolioCode: any) => {
    if (portfolioCode === activePortfolio) {
      setActivePortfolio(null);
    } else {
      setActivePortfolio(portfolioCode);
    }
  };

  return portfolioData ? (
    <div
      id="hfd"
      className="p-3 md:p-4 bg-white rounded-xl add-shadow flex-grow h-fit flex-col justify-start items-center gap-5 inline-flex slide-left"
    >
      <div className=" self-stretch flex-col justify-start items-center gap-3 flex">
        <div className=" self-stretch flex-col justify-start items-start gap-5 flex">
          <div className=" self-stretch flex-col justify-start items-start gap-5 flex">
            <div className="items-center gap-2 inline-flex w-full">
              <img
                src="/images/arrow-right.svg"
                className={clsx(
                  "cursor-pointer",
                  "rotate-180"
                )}
                width={24}
                height={24}
                alt="back"
                onClick={() => {
                  setShowCashDetails(false);
                  setShowAssetsDetails(false);
                  setShowFundDetails(false);
                }}
              />
              <div className=" flex grow text-[#2a2a2a] text-sm md:text-base font-bold">
                Hedge Funds
              </div>
            </div>
            <div className=" self-stretch flex-col justify-start items-start gap-3 flex">
              {Object.entries(portfolioData)?.map(([key, value]: any) => (
                <div key={key} className="flex flex-col w-full gap-3">
                  {view === "account" ? (
                    <div
                      className={clsx(
                        " cursor-pointer px-3 py-4 rounded-lg border-[1px] border-[#e3e3e3] flex-col justify-start items-start gap-4 flex",
                        activePortfolio === key
                          ? "bg-[#002f6c]"
                          : "bg-[#f6f6f6]"
                      )}
                      onClick={() => onAccountDetailsClicked(key)}
                    >
                      <div className="w-full flex-col justify-start items-start gap-2.5 flex">
                        <div className="w-full justify-start items-start gap-2 inline-flex">
                          <div className=" w-[18px] h-[18px] justify-center items-center flex">
                            {activePortfolio === key ? (
                              <img
                                src="/images/minus-icon.svg"
                                width={18}
                                height={18}
                                alt="minus"
                              />
                            ) : (
                              <img
                                src="/images/plus-icon.svg"
                                width={18}
                                height={18}
                                alt="plus"
                              />
                            )}
                          </div>
                          <div className=" w-full flex-col justify-start items-start gap-2 inline-flex">
                            <div className="w-full justify-between items-start w-380:items-center flex flex-col w-380:flex-row">
                              <div className=" justify-start items-center gap-1 flex">
                                <div
                                  className={clsx(
                                    " text-xs md:text-sm font-bold",
                                    activePortfolio === key
                                      ? "text-white "
                                      : "text-[#002f6c]"
                                  )}
                                >
                                  {key}
                                </div>
                                <div
                                  className={clsx(
                                    " opacity-70 text-[10px] md:text-xs font-normal",
                                    activePortfolio === key
                                      ? "text-white"
                                      : "text-[#2a2a2a]"
                                  )}
                                >
                                  (
                                  {

                                    getPortfolioTypeTranslation(
                                      value[0]?.portfolioGroupName
                                        ?.split("Portfolio")[0]
                                        ?.trim()
                                    )

                                  }
                                  )
                                </div>
                              </div>
                              <div
                                className={clsx(
                                  " text-xs md:text-sm font-bold",
                                  activePortfolio === key
                                    ? "text-white"
                                    : "text-[#535353]"
                                )}
                              >
                                {formatNumber(
                                  +getSumission(value, "reportingMarketAmount"),
                                  value[0]?.reportingCurrencyDcp
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {value?.map((item: any) => {
                    return (
                      <div
                        key={item?.id}
                        onClick={() => seeFundDetails(item)}
                        className={clsx(
                          "cursor-pointer self-stretch p-3 bg-[#fdfdfd] rounded-lg border border-[#e3e3e3]  gap-6",
                          activePortfolio == item.portfolioCode ||
                            view === "portfolio"
                            ? "flex flex-col justify-start items-start"
                            : "hidden"
                        )}
                      >
                        <div className=" self-stretch justify-between items-start inline-flex w-full">
                          <div className=" items-start flex flex-col">
                            <div className=" text-blue-500 text-xs md:text-[13px] font-semibold flex items-start gap-2">
                              {item?.disclaimerText && (
                                <Tooltip
                                  title={
                                    <ul>
                                      {item?.disclaimerText
                                        ?.split("#")
                                        ?.map((ele: any, index: number) => (
                                          <li key={index}>{ele}</li>
                                        ))}
                                    </ul>
                                  }
                                >
                                  <InfoCircleFilled
                                    className="cursor-pointer"
                                    style={{ color: "#ffa500" }}
                                  />
                                </Tooltip>
                              )}
                              {item[`secNameEn`]}{" "}
                            </div>
                          </div>
                          <div className="flex items-center gap-5">
                            <div
                              className="cursor-pointer w-6 h-6 justify-center items-center flex"
                              onClick={() => seeFundDetails(item)}
                            >
                              <img
                                src="/images/arrow-right.svg"
                                width={24}
                                height={24}
                                alt="arrow"
                                className={clsx(
                                  "cursor-pointer",

                                )}
                              />
                            </div>
                          </div>
                        </div>
                        <div className=" self-stretch flex-col justify-start items-center gap-3 flex">
                          <div className=" self-stretch justify-between items-start flex flex-wrap gap-y-5">
                            <div className="w-[49%] md:w-[33%] flex-col justify-start items-start gap-2 inline-flex">
                              <div className=" self-stretch justify-start items-end gap-1 inline-flex">
                                <div className=" grow shrink basis-0 text-[#949494] text-xs font-semibold">
                                  Quantity
                                </div>
                              </div>
                              <div className="Frame6279 self-stretch justify-start items-center gap-1 inline-flex">
                                <div className="00000 text-[#535353] text-xs font-semibold">
                                  {formatNumber(
                                    item.quantity,
                                    item?.quantityDecimal
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="w-[49%] md:w-[33%] flex-col justify-start items-start gap-2 inline-flex">
                              <div className="Frame6263 self-stretch justify-start items-start gap-1 inline-flex">
                                <div className="MarketValue w-[170px] text-[#949494] text-xs font-semibold">
                                  Market value
                                </div>
                              </div>
                              <div className=" self-stretch justify-start items-center gap-1 inline-flex">
                                <div className="00000 text-[#535353] text-xs font-semibold">
                                  {formatNumber(
                                    item?.investmentMarketAmount,
                                    item?.investmentCurrencyDcp
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="w-[49%] md:w-[33%] flex-col justify-start items-center gap-2 inline-flex">
                              <div className=" self-stretch justify-start items-start gap-1 inline-flex">
                                <div className="Currency grow shrink basis-0 text-[#949494] text-xs font-semibold">
                                  Inv. currency
                                </div>
                              </div>
                              <div className=" self-stretch justify-start items-center gap-1 inline-flex">
                                <div className="Sar text-[#535353] text-xs font-semibold">
                                  {item?.investmentCurrency}
                                </div>
                              </div>
                            </div>
                            <div className="w-[49%] md:w-[33%] flex-col justify-start items-start gap-2 inline-flex">
                              <div className="Frame6263 self-stretch justify-start items-end gap-1 inline-flex">
                                <div className="PaidAmount grow shrink basis-0 text-[#949494] text-xs font-semibold leading-none">
                                  Avg. Cost
                                </div>
                              </div>
                              <div className="Frame6279 self-stretch justify-start items-center gap-1 inline-flex">
                                <div className="00000 text-[#535353] text-xs font-semibold">
                                  {item?.avarageCost
                                    ? formatNumber(item?.avarageCost, 4)
                                    : "-"}
                                </div>
                              </div>
                            </div>
                            <div className="w-[49%] md:w-[33%] flex-col justify-start items-start gap-2 inline-flex">
                              <div className=" self-stretch justify-start items-start gap-1 inline-flex">
                                <div className=" grow shrink basis-0 text-[#949494] text-xs font-semibold leading-none">
                                  NAV
                                </div>
                              </div>
                              <div className=" self-stretch justify-start items-center gap-1 inline-flex">
                                <div className=" text-[#535353] text-xs font-semibold">
                                  {item?.portfolioMarketPrice
                                    ? formatNumber(
                                      item?.portfolioMarketPrice,
                                      4
                                    )
                                    : "-"}
                                </div>
                              </div>
                            </div>
                            <div className="w-[49%] md:w-[33%] flex-col justify-start items-center gap-2 inline-flex">
                              <div className=" self-stretch justify-start items-start gap-1 inline-flex">
                                <div className=" grow shrink basis-0 text-[#949494] text-xs font-semibold">
                                  "%Unreal. G/L
                                </div>
                              </div>
                              <div className="Frame6279 self-stretch justify-start items-center gap-1 inline-flex">
                                <div
                                  className={clsx(
                                    " text-xs font-semibold",
                                    item?.unrealPercentage >= 0
                                      ? "text-green-500"
                                      : "text-red-500"
                                  )}
                                >
                                  {item?.unrealPercentage
                                    ? item?.unrealPercentage > 0
                                      ? `${formatNumber(
                                        item?.unrealPercentage,
                                        2
                                      )}`
                                      : `(${formatNumber(
                                        Math.abs(item?.unrealPercentage),
                                        2
                                      )})`
                                    : "-"}
                                </div>
                              </div>
                            </div>
                          </div>
                          {item?.firstEventDate ? (
                            <div className=" self-stretch h-[15px] flex-col justify-start items-start gap-2 flex">
                              <div className=" self-stretch justify-start items-start gap-1 inline-flex">
                                <div className="Icons w-[15px] h-[15px] justify-center items-center flex">
                                  <img
                                    src="/images/outline-info-icon.svg"
                                    width={15}
                                    height={15}
                                    alt="info"
                                  />
                                </div>
                                <div className="InitialInvestmentDate15032017 text-[#535353] text-xs font-bold">
                                  Initial investment date:{" "}
                                  {item?.firstEventDate}
                                </div>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    ""
  );
};

export default AccountHedgeFunds;
